export function Waveform({ bars = 48, className = "", active = true, height = 64 }) {
  const arr = Array.from({ length: bars });
  return (
    <div className={`flex items-center justify-center gap-[3px] overflow-hidden ${className}`} style={{ height }} aria-hidden="true">
      {arr.map((_, i) => {
        const mid = Math.abs(i - bars / 2);
        const base = 0.3 + (1 - mid / (bars / 2)) * 0.7;
        return (
          <div
            key={i}
            className="wave-bar"
            style={{
              height: `${height}px`,
              animationDelay: `${(i % 12) * 0.09}s`,
              animationDuration: `${1.3 + (i % 5) * 0.18}s`,
              opacity: active ? base : 0.25,
              animationPlayState: active ? "running" : "paused",
            }}
          />
        );
      })}
    </div>
  );
}
